/**
 * https://docs.apryse.com/api/web/Core.html#.syncNamespaces__anchor
 */
export default (namespaces) => window.Core.syncNamespaces(namespaces);
